<template>
  <div class="dataDownload">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="60px"
        :model="formInline"
        inline
      >
        <el-form-item prop="title" label="标题">
          <el-input
            clearable
            v-model.trim="formInline.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title" v-if="checkAdmin()">
        <el-button
          size="small"
          type="primary"
          @click="openHandleDataDownload('add')"
          >新增</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="ID" width="260" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" minWidth="240" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.title || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.type || "--" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="大小" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <div>{{ handleRam(row.ram) }}</div>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" v-if="checkAdmin()" @click="openHandleDataDownload('alter', row)"
              >编辑</span
            >
            <span class="blue_Box" v-if="checkAdmin()" @click="handleDelete(row.id)">删除</span>
            <span class="blue_Box" v-if="row.url && !checkAdmin()" @click="handleDownload(row.url)">下载</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 新增、编辑 -->
    <HandleDataDownload ref="handleDataDownloadRef" />
  </div>
</template>

<script>
import {
  getCmsDocumentListPage,
  delCmsDocument,
} from "@/api/marketingAdmin/dataDownload.js";
import myPagination from "@/components/myPagination.vue";
import HandleDataDownload from "@/views/marketingAdmin/components/handleDataDownload.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "DataDownload",
  components: {
    myPagination,
    HandleDataDownload,
  },
  data() {
    return {
      loading: false,
      formInline: {
        title: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  created() {
    this.getCmsDocumentListPage({ page: 1, limit: 10 });
  },
  methods: {
    // 下载
    handleDownload(payload){
      window.open(payload);
    },
    // 文件大小单位转换
    handleRam(payload) {
      if (!payload) return "--";
      let kb = payload / 1024;
      let mb = (kb / 1024).toFixed(2);
      return `${mb}M`;
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该文件资料吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCmsDocument({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 新增、编辑
    openHandleDataDownload(status, payload) {
      this.$refs.handleDataDownloadRef.init(status, payload);
    },
    // 刷新
    refresh() {
      this.getCmsDocumentListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 请求列表
    async getCmsDocumentListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCmsDocumentListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getCmsDocumentListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getCmsDocumentListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCmsDocumentListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCmsDocumentListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dataDownload {
  .title {
    margin: 0px 0 10px;
  }

  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>